const DOC_TYPES = {
  taker: [
    { value: "NIF", label: "NIF / DNI" },
    { value: "NIE", label: "NIE / Tarjeta de residencia" },
    { value: "PASP", label: "Pasaporte" }
  ],
  takerHealth: [
    { value: "NIF" as "NIF", label: "NIF" },
    { value: "NIE" as "NIE", label: "NIE / Tarjeta de residencia" },
    { value: "PAS" as "PAS", label: "Pasaporte" }
  ],
  takerHealthVisa: [
    { value: "PAS", label: "Pasaporte" }
  ],
  takerTravelLegalPerson: [
    { value: "CIF", label: "CIF" },
    { value: "CIE", label: "CIE" }
  ],
  insuredsHealth: [
    { value: "NIF", label: "NIF / DNI" },
    { value: "NIE", label: "NIE / Tarjeta de residencia" },
    { value: "PAS", label: "Pasaporte" },
    { value: "NIFP", label: "NIFP" },
    { value: "MENOR", label: "Menores" }
  ],
  insuredHealthVisa: [
    { value: "PAS", label: "Pasaporte" }
  ],
  others: [
    { value: "NIF", label: "NIF / DNI" },
    { value: "NIE", label: "NIE / Tarjeta de residencia" },
    { value: "PASP", label: "Pasaporte" }
  ],
};

export default DOC_TYPES;
